export default {
    risksMenu: 'Análisis del riesgo',
    riskMaps: 'Mapas de calor',
    riskMapsMenu: 'Evaluación del riesgo',
    risks: 'Riesgos',
    totalRisks: 'Total de riesgos',
    valoratedRisks: 'Riesgos analizados',
    risksOfThreat: 'Riesgos de la amenaza',
    probability: 'Probabilidad',
    showAssetsRisk: 'Mostrar activos con riesgos',
    showCriticalAssets: 'Mostrar activos críticos',
    threatCategory: 'Categoría/Subcategoría',
    threatAsset: 'Amenaza/Activo',
    selectMeasure: 'Selecciona una valoración o calificación',
    selectProbability: 'Selecciona probabilidad',
    noFactorsMessage: 'Aún no ha seleccionado los factores de impacto que aplican para este activo',
    noThreatsMessage: 'Este activo aún no tiene amenazas asociadas. Para realizar el cálculo de riesgo es necesario identificar las posibles amenazas que podrían afectar a este activo.',
    riskLevel: 'Nivel de riesgo',
    saveRisk: 'Guardar Riesgo',
    noRiskZone: 'No hay riesgos en esta zona',
    noRisksMessage: 'Aún no tienes riesgos calculados, si deseas calcular el riesgo de tus activos, puedes hacerlo en la sección de análisis de riesgo.',
    defineCriticy: 'Definir criticidad del activo',
    identify: 'Identificar',
    risk: 'Riesgo',
    riskRecognition: 'Identificación de riesgo',
    riskGuideMessage: 'El nivel de riesgo se calcula automáticamente multiplicando la probabilidad de que ocurra un evento por el impacto potencial sobre el activo, proporcionando una evaluación precisa del riesgo con respecto a sus amenazas asociadas.',
    riskZoneMapsGuideMessage: 'Este módulo te permite visualizar de forma clara los niveles de riesgo asociados a los activos de tu organización, mediante una matriz de colores basada en la probabilidad y el impacto. Esto facilita la priorización de los controles adecuados.',
    noAssetsMessageTitle: 'No tienes activos a los cuales evaluar riesgos.',
    noAssetsMessage: 'Para evaluar riesgos, primero debes crear un activo.',
    noRisksMessageTitle: 'Aún no tienes riesgos calculados.',
    noRisksControlMessageTitle: 'Aún no tienes controles creados.',
    noRisksControlMessage: 'Si deseas crear controles a tus riesgos, puedes hacerlo en la sección de cálculo de riesgo.',
    noRisksFollowMessageTitle: 'Aún no tienes riesgos a los cuales hacerle seguimiento.',
    noRisksFollowMessage: 'Si deseas calcular el riesgo de tus activos, puedes hacerlo en la sección de cálculo de riesgo.',
    riskStatus: 'Estado del riesgo',
    saveControlError: 'Error al guardar el control',
    controlUpdated: 'Control actualizado con éxito',
    controlUpdateError: 'Error al actualizar el control',
    controlActionError: 'Error al consultar las acciónes de control',
    errorLoadingControls: 'Error al cargar los controles',
    participantError: 'Error al cargar los participantes',
    saveFollowError: 'Error al guardar el seguimiento',
    followSaved: 'Seguimiento guardado',
    controlDomainError: 'Error al cargar los dominios de control',
    controlError: 'Error al cargar el control',
    impactAreaError: 'Error al cargar el factor de impacto',
    controlSaved: 'Control asociado con éxito',
    riskSaved: 'Riesgo guardado con éxito',
    downloadMap: 'Descargar mapa de calor',
    alerts: {
        incompleteRisk: 'Riesgo Incompleto',
        incompleteRiskMessage: 'Tiene amenazas con probabilidad seleccionada pero sin factores de impacto asignados. Complete la valoración del riesgo antes de continuar.',
        missingImpactFactors: 'Esta amenaza tiene probabilidad seleccionada pero le faltan factores de impacto.'
    }

};
